import React from 'react'
import { Dialog, DialogContent, LinearProgress, makeStyles } from '@material-ui/core'

const useStyles = makeStyles({
  rootBackdrop: { position: 'absolute' }
})

function LoadingEcommerce({ isLoading }) {
  const classes = useStyles()

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={isLoading}
      container={document.getElementById('gofind-finder') || document.body}
      style={{ position: 'absolute' }}
      BackdropProps={{
        classes: { root: classes.rootBackdrop }
      }}
    >
      <DialogContent style={{ padding: 0 }}>
        <LinearProgress style={{ width: '100%' }} />
      </DialogContent>
    </Dialog>
  )
}

export default LoadingEcommerce
